import React from 'react'
import cx from 'classnames'
import { Spring, Trail, config } from 'react-spring/renderprops.cjs'
import { hyphenateString, isTablet } from '/js/util'
import Logo from '/img/svg/logo'

const DEFAULT_OVERLAYNAV_CLASSES = `block
  border-columbia-blue
  border-t
  no-underline
  hover:underline
  pb-10
  pt-10
  text-14`

class StoryOverlayNavigation extends React.Component {
  generateNavigationItems() {
    const { cards, theme, handleNavigationClick } = this.props

    return cards.map((item, index) => (
      <li
        key={`nav-item-${index}`}
        className="nav-item"
        data-label="card-overlay-nav-list-item"
      >
        <a
          href={`#${hyphenateString(item.sectionTitle)}`}
          data-track-gtm={`Story Overlay|Side Navigation Panel|${item.sectionTitle}`}
          className={cx(DEFAULT_OVERLAYNAV_CLASSES, {
            'border-b': index === cards.length - 1
          })}
          onClick={() => handleNavigationClick(index)}
        >
          {item.sectionTitle}
        </a>
      </li>
    ))
  }

  renderIcon() {
    const { icon } = this.props
    return (
      <Spring
        from={{ transform: 'translate3d(0,40px,0)', opacity: 0 }}
        to={{ transform: 'translate3d(0,0,0)', opacity: 1 }}
        config={config.slow}
      >
        {props => (
          <div
            style={props}
            data-label="card-overlay-icon"
            className="justify-center mb-48 w-135"
            dangerouslySetInnerHTML={{ __html: icon }}
          />
        )}
      </Spring>
    )
  }

  renderLogo() {
    return (
      <Spring
        from={{ transform: 'translate3d(0,100px,0)', opacity: 0 }}
        to={{ transform: 'translate3d(0,0,0)', opacity: 1 }}
        config={config.slow}
      >
        {props => <Logo style={props} className="w-170" />}
      </Spring>
    )
  }

  renderNavigation() {
    const { title } = this.props

    return (
      <div>
        <h2 className="uppercase font-condensed text-24 mb-20">
          {title} <span className="screenreader">navigation</span>
        </h2>
        <nav data-label="card-overlay-nav-list-item">
          <Spring
            from={{ transform: 'translate3d(20px,0,0)', opacity: 0 }}
            to={{ transform: 'translate3d(0,0,0)', opacity: 1 }}
            config={config.slow}
          >
            {props => <ul style={props}>{this.generateNavigationItems()}</ul>}
          </Spring>
        </nav>
      </div>
    )
  }

  renderNavigationContent() {
    return (
      <div className="flex flex-col justify-between pt-45 pb-32 px-25 md:px-30 h-full">
        <div>
          {this.renderIcon()} {this.renderNavigation()}
        </div>
        {this.renderLogo()}
      </div>
    )
  }

  render() {
    const { isMobileNavigationOpen } = this.props
    const navigationClasses = 'h-full bg-smoke-white'

    if (isTablet()) {
      return (
        <Spring
          to={{
            transform: isMobileNavigationOpen
              ? 'translate3d(0,0,0)'
              : 'translate3d(100%,0,0)',
            opacity: isMobileNavigationOpen ? 1 : 0
          }}
        >
          {props => (
            <div
              style={props}
              className={`w-full absolute z-5 ${navigationClasses}`}
            >
              {this.renderNavigationContent()}
            </div>
          )}
        </Spring>
      )
    }

    return (
      <div className={`max-w-372 relative ${navigationClasses}`}>
        {this.renderNavigationContent()}
      </div>
    )
  }
}

export default StoryOverlayNavigation
